import { render } from "./EmojiSelectionMenu.vue?vue&type=template&id=b4a6653e&ts=true&lang=html"
import script from "./EmojiSelectionMenu.vue?vue&type=script&lang=ts"
export * from "./EmojiSelectionMenu.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__